class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* ── Save for Later ────────────────────────────────────── */

(function () {
  let undoTimeout = null;
  let undoData = null;
  let toastEl = null;

  function ensureToast() {
    if (toastEl && toastEl.parentNode) return toastEl;

    toastEl = document.createElement('div');
    toastEl.id = 'CartDrawer-SaveForLaterToast';
    toastEl.style.cssText = 'display:none;background:#f8f8f8;border-top:1px solid #e5e5e5;padding:0.8rem 1.6rem;';
    toastEl.innerHTML =
      '<div style="display:flex;align-items:center;justify-content:space-between;">' +
        '<div style="display:flex;align-items:center;gap:0.5rem;">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="#85a097" stroke="#85a097" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
          '<span style="font-family:Roboto,sans-serif;font-size:1.2rem;color:#121212;letter-spacing:0.02em;">Auf Wunschliste gespeichert</span>' +
        '</div>' +
        '<button type="button" id="CartDrawer-UndoSaveForLater" style="border:0;background:transparent;font-family:Roboto,sans-serif;font-size:1.2rem;font-weight:700;color:#85a097;cursor:pointer;text-decoration:underline;letter-spacing:0.02em;padding:0;">Rückgängig</button>' +
      '</div>' +
      '<div id="CartDrawer-SaveForLaterProgress" style="margin-top:0.8rem;border-radius:9999px;background:#85a097;width:100%;height:4px;transition:width 5s linear;font-size:0;">&nbsp;</div>';

    // Insert directly above .drawer__footer
    var footer = document.querySelector('.drawer__footer');
    if (footer && footer.parentNode) {
      footer.parentNode.insertBefore(toastEl, footer);
    }
    return toastEl;
  }

  function showToast() {
    const toast = ensureToast();
    if (!toast) return;
    toast.style.display = 'block';
    toast.style.opacity = '1';
    toast.style.opacity = '1';
    toast.style.transition = '';

    const progress = document.getElementById('CartDrawer-SaveForLaterProgress');
    if (progress) {
      progress.style.transition = 'none';
      progress.style.width = '100%';
      progress.offsetHeight;
      progress.style.transition = 'width 5s linear';
      progress.style.width = '0%';
    }

    clearTimeout(undoTimeout);
    undoTimeout = setTimeout(() => {
      if (toast) {
        toast.style.transition = 'opacity 0.3s ease';
        toast.style.opacity = '0';
        setTimeout(() => {
          toast.style.display = 'none';
          toast.style.opacity = '';
          toast.style.transition = '';
        }, 300);
      }
      undoData = null;
    }, 5000);
  }

  function hideToast() {
    if (toastEl) {
      toastEl.style.display = 'none';
      toastEl.style.opacity = '';
      toastEl.style.transition = '';
    }
    clearTimeout(undoTimeout);
  }

  var cartChangeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change.js';
  var cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

  async function removeFromCart(lineIndex) {
    const body = JSON.stringify({
      line: lineIndex,
      quantity: 0,
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname,
    });

    const response = await fetch(cartChangeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body,
    });
    if (!response.ok) {
      console.error('[Save for Later] removeFromCart failed:', response.status);
      return {};
    }
    return await response.json();
  }

  async function addToCart(variantId, quantity) {
    const body = JSON.stringify({
      items: [{ id: parseInt(variantId), quantity: quantity || 1 }],
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname,
    });

    const response = await fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body,
    });
    if (!response.ok) {
      console.error('[Save for Later] addToCart failed:', response.status);
      return {};
    }
    return await response.json();
  }

  function rerenderCartDrawer(parsedState) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    const sections = parsedState.sections || {};
    const drawerHTML = sections['cart-drawer'];
    const bubbleHTML = sections['cart-icon-bubble'];

    if (drawerHTML) {
      const drawerEl = document.getElementById('CartDrawer');
      if (drawerEl) {
        const doc = new DOMParser().parseFromString(drawerHTML, 'text/html');
        const newInner = doc.querySelector('.drawer__inner');
        const currentInner = document.querySelector('.drawer__inner');
        if (newInner && currentInner) {
          currentInner.innerHTML = newInner.innerHTML;
        }
      }
    }

    if (bubbleHTML) {
      const bubbleEl = document.getElementById('cart-icon-bubble');
      if (bubbleEl) {
        const doc = new DOMParser().parseFromString(bubbleHTML, 'text/html');
        bubbleEl.innerHTML = doc.querySelector('.shopify-section').innerHTML;
      }
    }

    const itemCount = parsedState.item_count ?? 0;
    if (cartDrawer) {
      cartDrawer.classList.toggle('is-empty', itemCount === 0);
    }

    bindSaveForLaterButtons();
  }

  function bindSaveForLaterButtons() {
    document.querySelectorAll('.cart-drawer__save-for-later').forEach((btn) => {
      if (btn.dataset.bound) return;
      btn.dataset.bound = 'true';

      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const handle = btn.dataset.productHandle;
        const variantId = btn.dataset.variantId;
        const title = btn.dataset.productTitle;
        const price = parseInt(btn.dataset.productPrice) || null;
        const imageUrl = btn.dataset.productImage;
        const productUrl = btn.dataset.productUrl;
        const lineIndex = parseInt(btn.dataset.lineIndex);

        if (window.Wishlist) {
          window.Wishlist.saveForLater(handle, {
            price,
            name: title,
            variantId,
            imageUrl,
            productUrl,
          });
        }

        undoData = { handle, variantId, quantity: 1 };

        try {
          const parsedState = await removeFromCart(lineIndex);
          if (parsedState && parsedState.sections) {
            rerenderCartDrawer(parsedState);
          }
        } catch (err) {
          console.error('[Save for Later] Remove from cart failed:', err);
        }
        // Show toast regardless — item was already added to wishlist
        setTimeout(showToast, 150);
      });
    });
  }

  document.addEventListener('click', async (e) => {
    const undoBtn = e.target.closest('#CartDrawer-UndoSaveForLater');
    if (!undoBtn) return;
    e.preventDefault();
    e.stopPropagation();
    if (!undoData) return;

    const data = { ...undoData };
    undoData = null;
    hideToast();

    if (window.Wishlist) {
      window.Wishlist.remove(data.handle);
    }

    try {
      const parsedState = await addToCart(data.variantId, data.quantity);
      if (parsedState && parsedState.sections) {
        rerenderCartDrawer(parsedState);
      } else {
        // Fallback: fetch fresh cart drawer section
        var resp = await fetch('/?sections=cart-drawer,cart-icon-bubble');
        var sections = await resp.json();
        rerenderCartDrawer({ sections: sections, item_count: 1 });
      }
      // Ensure drawer shows non-empty state
      var cartDrawerEl = document.querySelector('cart-drawer');
      if (cartDrawerEl) {
        cartDrawerEl.classList.remove('is-empty');
        var innerEmpty = cartDrawerEl.querySelector('.drawer__inner-empty');
        if (innerEmpty) innerEmpty.style.display = 'none';
      }
    } catch (err) {
      console.error('[Save for Later] Undo failed:', err);
    }
  });

  // Bind on page load
  document.addEventListener('DOMContentLoaded', bindSaveForLaterButtons);

  // Re-bind whenever the cart drawer DOM changes (section re-render, renderContents, etc.)
  var drawerObserver = new MutationObserver(function () {
    bindSaveForLaterButtons();
  });

  function observeDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (drawer) {
      drawerObserver.observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeDrawer);
  } else {
    observeDrawer();
  }
})();
